import { useEffect, useState } from "react";
import { webUrlNode } from "../../constants/appInfo";
import { useSelector } from "react-redux";
 import { useHistory,} from "react-router-dom";
export default function AdminSystemInventory() {
 const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
      const history = useHistory();
  if(!appToken){
  
  
       history.push(`/apps`);
  }

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [adding, setAdding] = useState({}); // id -> addCredits

  useEffect(() => {
    load();
  }, []);

  async function load() {
    setLoading(true);

    const r = await fetch(
      `${webUrlNode}/api/admin/credits/system-inventory?appToken=${appToken}&currentToken=${currentToken}`,
      
    );

    const j = await r.json();
    setRows(j.length?j : []);
    setLoading(false);
  }

  async function saveTopup(row) {

    const addCredits = Number(adding[row.id] || 0);
    if (!addCredits || addCredits <= 0) {
      alert("Enter valid credits to add");
      return;
    }

    await fetch(
      `${webUrlNode}/api/admin/credits/system-inventory/${row.id}`,
      {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        
        body: JSON.stringify({
          addCredits
        })
      }
    );

    setAdding(v => ({ ...v, [row.id]: "" }));
    load();
  }

  async function toggleSelling(row) {

    await fetch(
      `${webUrlNode}/api/admin/credits/system-inventory/${row.id}`,
      {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        
        body: JSON.stringify({
          allowSelling:
            row.allowSelling === "true" ? "false" : "true"
        })
      }
    );

    load();
  }
function SellingBadge({ active }) {
  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 600,
        background: active ? "#dcfce7" : "#fee2e2",
        color: active ? "#16a34a" : "#dc2626"
      }}
    >
      {active ? "ON" : "OFF"}
    </span>
  );
}
  return (
      <div style={styles.wrapper}>

      <h2 style={styles.heading}>System Credit Inventory</h2>

      {loading && <div style={styles.loading}>Loading...</div>}

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th>Channel</th>
              <th>Provider</th>
              <th>Total</th>
              <th>Used</th>
              <th>Remaining</th>
              <th>Selling</th>
              <th>Top-up</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {rows.map(r => {
              const lowStock =
                Number(r.remainingCredits) <
                Number(r.totalCredits) * 0.2;

              return (
                <tr
                  key={r.id}
                  style={
                    lowStock ? styles.lowStockRow : null
                  }
                >
                  <td style={{ textTransform: "capitalize" }}>
                    {r.channel}
                  </td>

                  <td>{r.provider}</td>

                  <td>{r.totalCredits}</td>

                  <td>{r.usedCredits}</td>

                  <td style={styles.remainingCell}>
                    {r.remainingCredits}
                    {lowStock && (
                      <span style={styles.lowBadge}>
                        Low
                      </span>
                    )}
                  </td>

                  <td>
                    <SellingBadge
                      active={r.allowSelling === "true"}
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      placeholder="+ credits"
                      value={adding[r.id] || ""}
                      onChange={e =>
                        setAdding(v => ({
                          ...v,
                          [r.id]: e.target.value
                        }))
                      }
                      style={styles.topupInput}
                    />
                  </td>

                  <td style={styles.actions}>
                    <button
                      style={styles.addBtn}
                      onClick={() => saveTopup(r)}
                    >
                      Add
                    </button>

                    <button
                      style={styles.toggleBtn}
                      onClick={() =>
                        toggleSelling(r)
                      }
                    >
                      {r.allowSelling === "true"
                        ? "Disable"
                        : "Enable"}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
<style>
        {`
        
table th {background:#f9f9f9; padding:10px}
         
table td {background:#ffffff; padding:10px}
        `} </style>
    </div>
  );
}
const styles = {
  wrapper: {
    padding: 24,
    background: "#f8fafc",
    
    fontFamily: "Inter, sans-serif"
  },

  heading: {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 20
  },

  loading: {
    marginBottom: 15
  },

  tableWrapper: {
    overflowX: "auto",
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 6px 25px rgba(0,0,0,0.05)"
  },

  table: {
    width: "100%",textAlign:"center",
    borderCollapse: "collapse",
    minWidth: 1000
  },

  remainingCell: {
    fontWeight: 600
  },

  lowStockRow: {
    background: "#fff7ed"
  },

  lowBadge: {
    marginLeft: 6,
    background: "#f97316",
    color: "#fff",
    fontSize: 10,
    padding: "2px 6px",
    borderRadius: 10
  },

  topupInput: {
    padding: "6px 8px",
    borderRadius: 6,
    border: "1px solid #e5e7eb",
    width: 100
  },

  actions: {
    display: "flex",
    gap: 8
  },

  addBtn: {
    padding: "6px 12px",
    borderRadius: 8,
    border: "none",
    background: "#4f46e5",
    color: "#fff",
    cursor: "pointer",
    fontWeight: 600
  },

  toggleBtn: {
    padding: "6px 12px",
    borderRadius: 8,
    border: "1px solid #e5e7eb",
    background: "#fff",
    cursor: "pointer"
  }
};